import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APP_CONFIG } from '../../../app.config';

@Injectable({
  providedIn: 'root'
})
export class PMASettingsService {

  REST_API: string = APP_CONFIG.API_ENDPOINT;
  API_URL = `${this.REST_API}`;
  REST_No_API: string = APP_CONFIG.NO_API_ENDPOINT;
  NO_API_URL = `${this.REST_No_API}`;

  constructor(private http: HttpClient) { }

  getPMASettings(): Observable<any> {
    return this.http.get(this.API_URL+'/propertyManagementAccounts/findPropertyManagementAccountSetting')
      .pipe(
        catchError(this.handleError)
      )
  }

  updatePMASettings(data): Observable<any> {
    return this.http.post(this.API_URL+'/propertyManagementAccounts/editPropertyManagementAccountSettingNG',data)
      .pipe(
        catchError(this.handleError)
      )
  }

  deleteTaxCertificate(data): Observable<any> {
    return this.http.post(this.API_URL+'/propertyManagementAccounts/deletePMATaxDoc',data)
      .pipe(
        catchError(this.handleError)
      )
  }

  deletePMSLogo(data): Observable<any> {
    return this.http.post(this.API_URL+'/propertyManagementAccounts/deletePropertyManagementAccountLogoLink',data)
      .pipe(
        catchError(this.handleError)
      )
  }

  deletePMSDoc(data): Observable<any> {
    return this.http.post(this.API_URL+'/propertyManagementAccounts/deletePMANormalDoc',data)
      .pipe(
        catchError(this.handleError)
      )
  }

  addPmsSettingsDocs(data): Observable<any> {
    return this.http.post(this.API_URL+'/propertyManagementAccounts/createPMADoc',data)
      .pipe(
        catchError(this.handleError)
      )
  }

  getPmaSettingsDoc(data): Observable<any> {
    return this.http.get(this.NO_API_URL+'/findTableInformationByFieldNameAndId'+this.jsonToQueryString(data))
      .pipe(
        catchError(this.handleError)
      )
  }

  getCurrentUserImg(): Observable<any> {
    return this.http.get(this.API_URL+'/propertyManagementAccounts/findPropertyManagementAccountLogoLink')
      .pipe(
        catchError(this.handleError)
      )
  }

   // Error 
   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Handle client error
      errorMessage = error.error.message;
    } else {
      // Handle server error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    if(error.message.includes('login')){
      localStorage.removeItem('user');
      localStorage.removeItem('sessionID');
      localStorage.removeItem('token');
      window.location.reload();
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  jsonToQueryString(json) {
    return '?' + 
        Object.keys(json).map(function(key) {
            return encodeURIComponent(key) + '=' +
                encodeURIComponent(json[key]);
        }).join('&');
  }
}
